import { ReservationStatusType } from "../models/base/ReservationStatusType";
import { TableShapeType } from "../models/base/TableShapeType";

export const ReservationStatus = (status: ReservationStatusType): string => {
    switch (status) {
        case ReservationStatusType.Waiting:
            return "Na čekanju";
        case ReservationStatusType.Confirmed:
            return "Potvrđeno";
        case ReservationStatusType.Canceled:
            return "Otkazano";
        case ReservationStatusType.Finished:
            return "Završeno";
        case ReservationStatusType.DontShowUp:
            return "Nije došao";
        default:
            return "Nepoznato";
    }
};

export const TableShape = (shape: TableShapeType): string => {
    switch (shape) {
        case TableShapeType.Rectangle:
            return "Pravougaoni";
        case TableShapeType.Round:
            return "Okrugli";
        case TableShapeType.Square:
            return "Kvadratni";
        case TableShapeType.Triangle:
            return "Trouglasti";
        default:
            return "Nepoznato";
    }
}